/* global chrome */
import React, {useState, useContext, useEffect} from 'react';
import {Link, withRouter} from 'react-router-dom';
import authApi from '../services/api/auth';
import {GlobalContext} from "../context/GlobalState";
import "../styles/auth.scss";
import Logo from '../images/logo-full.svg';
import EmailIcon from '../images/icons/email-icon.svg';
import PasswordIcon from '../images/icons/password-icon.svg';
import SVG from 'react-inlinesvg';
import SponsoredChannels from '../components/SponsoredChannels';
import ReactGA from 'react-ga';
import Plaudy from "plaudy";

const Signup = ({history}) => {
  const {logIn, userData} = useContext(GlobalContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (userData && userData.accountLevel) {
    history.push('/home');
  }

  const updateEmail = e => {
    setEmail(e.target.value);
  };

  const updatePassword = e => {
    setPassword(e.target.value);
  };

  const handleSignup = async e => {
    e.preventDefault();
    try {
      const data = {
        email,
        password,
      };

      const response = await authApi.signUp(data);
      const userData = response.data;
      ReactGA.event({
        category: 'User',
        action: 'Signed Up',
        value: userData.email,
      });
      Plaudy.track('signup', {
        email: userData.email,
        userId: userData.id,
      });
      logIn({userData});

      const extensionId = "hemjflepggljigpcaneoeldgipbpcbmg";

      if (chrome) {
        chrome.runtime.sendMessage(extensionId, {type: 'autoLogin', token: userData.loginToken});
      }

      history.push('/home');
    } catch (error) {
      if (typeof error.response.data === 'string') {
        console.log('ERROR:', error.response.data);
        setError(error.response.data);
      } else {
        console.log('ERROR:', error);
        setError('Please enter a valid email and password and try again.');
      }
    }
  };

  return (
    <div className="auth-container signup">
      <SponsoredChannels />

      <div className="form">
        <div className="logo-container">
          <img src={Logo} alt="logo" />
        </div>
        <h1>Start your free trial</h1>
        <p className="login-link">Already have an account? <Link to='/login'>Log in</Link></p>
        {error && <p className="error">{error}</p>}
        <form>
          <div className="input-wrapper">
            <input value={email} onChange={updateEmail} placeholder='Email' type='email' required/>
            <SVG src={EmailIcon} />
          </div>
          <div className="input-wrapper">
            <input value={password} onChange={updatePassword} placeholder='Password' type='password' required/>
            <SVG src={PasswordIcon} />
          </div>
          <button onClick={handleSignup} className="button-primary wide">Create account</button>
        </form>

        <p>By signing up, you are agreeing to <a href="https://getrocketnote.com/terms-of-service" target="_blank">Rocket Note's Terms & Conditions</a></p>

        <div className="copyright">

        </div>
      </div>
    </div>
  );
};

export default withRouter(Signup);
